import { getMomentObjectInTimezone } from 'base/new-utils';
import PropTypes from 'prop-types';

const EmailCardBody = ({ email = {}, isLabelFilterApplied = false, filterType = '' }) => {
  const { subject, parsed_body, created_at, scheduled_at, status, nylas_schedule_id, sent_at } = email;

  const getDisplayDateInfo = () => {
    if (status === 'SENT' || status === 'REPLIED') {
      if (isLabelFilterApplied) {
        return {
          label: filterType === 'Reply' ? 'Reply received' : filterType === 'Sent' ? 'Sent' : 'Sent',
          date: getMomentObjectInTimezone(sent_at * 1000)?.format('MMM D, YYYY'),
          time: getMomentObjectInTimezone(sent_at * 1000)?.format('h:mm A'),
        };
      } else if (!isLabelFilterApplied) {
        return {
          label: 'Sent',
          date: getMomentObjectInTimezone(sent_at * 1000)?.format('MMM D, YYYY'),
          time: getMomentObjectInTimezone(sent_at * 1000)?.format('h:mm A'),
        };
      }
    } else if (status === 'DRAFT' && nylas_schedule_id) {
      return {
        label: 'Scheduled',
        date: getMomentObjectInTimezone(scheduled_at * 1000)?.format('MMM D, YYYY'),
        time: getMomentObjectInTimezone(scheduled_at * 1000)?.format('h:mm A'),
      };
    } else {
      return {
        label: 'Created',
        date: getMomentObjectInTimezone(created_at * 1000)?.format('MMM D, YYYY'),
        time: getMomentObjectInTimezone(created_at * 1000)?.format('h:mm A'),
      };
    }
  };

  const { label, date, time } = getDisplayDateInfo();

  return (
    <div className="email-card-body">
      <div className="email-card-body-left">
        <h5>{subject || '(no subject)'}</h5>
        <p>{parsed_body || '(empty)'}</p>
      </div>
      <div className="email-card-body-right">
        <p>{`${label} ${filterType !== '' ? 'on' : 'at'} ${date}`}</p>
        {time && <p>{time}</p>}
      </div>
    </div>
  );
};

EmailCardBody.propTypes = {
  email: PropTypes.object.isRequired,
  isLabelFilterApplied: PropTypes.bool,
  filterType: PropTypes.string,
};

export default EmailCardBody;
